module.exports = __webpack_public_path__ + "static/media/logo.521905c8.png";